/* eslint-disable */
import React, { useEffect, useState, useRef } from 'react';
import moment from 'moment';

// components
import { DateRangePicker } from 'react-date-range';

// actions
import { useOutsideClick } from '../hooks';

// This component can be pulled out and used elsewhere. All you need to pass it is
// the state props `startDate` and `endDate` and the setters (redux dispatch actions
// or state setter functions, whatever is used to set `startDate` and `endDate`)
function DateRangeFilter({
  defaultDaysSelection = 7, // if this is set to a falsey value there will be no default selection
  startSetter = () => {},
  endSetter = () => {},
  startDate,
  endDate,
}) {
  const ref = useRef();
  const [ display, setDisplay ] = useState(false);

  function handleChange(range) {
    const sd = moment(range.selected.startDate).format('YYYY-MM-DD');
    const ed = moment(range.selected.endDate).format('YYYY-MM-DD');
    startSetter(sd);
    endSetter(ed);
  }

  function renderInputDisplay(sd, ed) {
    const formattedStart =  sd ? moment(startDate).format('MM/DD/YYYY') : 'Start Date';
    const formattedEnd = ed ? moment(endDate).format('MM/DD/YYYY') : 'End Date';
    return `${formattedStart} - ${formattedEnd}`;
  }

  function handleClear() {
    startSetter(undefined);
    endSetter(undefined);
  }

  useOutsideClick(ref, () => {
    setDisplay(false);
  });

  useEffect(() => {
    // when component initially loads set a default start and end date from today
    if (!defaultDaysSelection) {
      startSetter(undefined);
      startSetter(undefined);
    } else {
      startSetter(moment().subtract(Number(defaultDaysSelection), 'days').format('YYYY-MM-DD'));
      endSetter(moment().format('YYYY-MM-DD'));
    }
  }, []);

  const selectionRange = {
    startDate: moment(startDate).toDate(),
    endDate: moment(endDate).toDate(),
    key: 'selected',
  }

  return (
    <>
      <div className="input-group">
        <input
          className="form-control"
          onFocus={() => setDisplay(true)}
          value={renderInputDisplay(startDate, endDate)}
          onChange={() => {}}
        />
        <button className="btn btn-outline-danger" onClick={handleClear}>
          x
        </button>
      </div>
      <div
        ref={ref}
        style={{
          position: 'absolute',
          zIndex: 9999,
          display: display ? 'block' : 'none',
        }}
      >
        <DateRangePicker
          onChange={handleChange}
          ranges={[selectionRange]}
          direction="horizontal"
        />
      </div>
    </>
  )
}

export default DateRangeFilter;
